export default __webpack_public_path__ + "30f3dd1af7f64d467de92b242868f137.png";